import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import activityReducer from "../reducer/activity/activityReducer";
import authReducer from "../reducer/auth/authReducer";
import bankReducer from "../reducer/bank/bankReducer";
import employeeReducer from "../reducer/employee/employeeReducer";
import jobPositionReducer from "../reducer/jobPosition/jobPositionReducer";
import priceTypeReducer from "../reducer/priceType/priceTypeReducer";
import roleReducer from "../reducer/role/roleReducer";
import unitWeightReducer from "../reducer/unitWeight/unitWeightReducer";
import vegetableTypeReducer from "../reducer/vegetableType/vegetableTypeReducer";
import userManagementReducer from "../reducer/userManagement/userManagementReducer";
import workingAreaReducer from "../reducer/workingArea/workingAreaReducer";
import workingStatusReducer from "../reducer/workingStatus/workingStatusReducer";
import vegetableReducer from "../reducer/vegetable/vegetableReducer";
import vegetablePriceReducer from "../reducer/vegetablePrice/vegetablePriceReducer";
import calendarReducer from "../reducer/calendar/calendarReducer";
import farmerReducer from "../reducer/farmer/farmerReducer";
import customerGroupReducer from "../reducer/customerGroup/customerGroupReducer";
import customerRegionReducer from "../reducer/customerRegion/customerRegionReducer";
import goodsCategoryReducer from "../reducer/goodsCategory/goodsCategoryReducer";
import goodsOperationalReducer from "../reducer/goodsOperational/goodsOperationalReducer";
import deliveryVehicleReducer from "../reducer/deliveryVehicle/deliveryVehicleReducer";
import customerReducer from "../reducer/customer/customerReducer";
import dailyActivityReducer from "../reducer/dailyActivity/dailyActivityReducer";
import reportDailyActivityReducer from "../reducer/dailyActivity/reportDailyActivityReducer";
import harvestEstimateReducer from "../reducer/harvest-estimate/harvestEstimateReducer";
import harvestReducer from "../reducer/harvest/harvestReducer";
import reportHarvestEstimateReducer from "../reducer/harvest-estimate/reportHarvestEstimateReducer";
import reportHarvestReducer from "../reducer/harvest/reportHarvestReducer";
import purchaseOrderReducer from "../reducer/purchaseOrder/purchaseOrderReducer";
import leftBarReducer from "../reducer/leftbar/leftBarReducer";
import purchaseOrderCustReducer from "../reducer/purchaseOrderCust/purchaseOrderCustReducer";
import stockVegetablesReducer from "../reducer/stock-vegetables/stockVegetablesReducer";
import deliveryOrderReducer from "../reducer/deliveryOrder/deliveryOrderReducer";
import stockOperationalGoodsReducer from "../reducer/stock-operational-goods/stockOperationalGoodsReducer";
import invoiceReducer from "../reducer/invoice/invoiceReducer";
import debtPlasticReducer from "../reducer/debtPlastic/debtPlasticReducer";
import operationalSubmissionReducer from "../reducer/operationalSubmission/operationalSubmissionReducer";
import debtMoneyReducer from "../reducer/debtMoney/debtMoneyReducer";
import purchaseOrderFarmerReducer from "../reducer/purchaseOrderFarmer/purchaseOrderFarmerReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  calendar: calendarReducer,
  activity: activityReducer,
  role: roleReducer,
  bank: bankReducer,
  jobPosition: jobPositionReducer,
  priceType: priceTypeReducer,
  workingArea: workingAreaReducer,
  workingStatus: workingStatusReducer,
  employee: employeeReducer,
  farmer: farmerReducer,
  unitWeight: unitWeightReducer,
  vegetable: vegetableReducer,
  vegetableType: vegetableTypeReducer,
  vegetablePrice: vegetablePriceReducer,
  customerGroup: customerGroupReducer,
  customerRegion: customerRegionReducer,
  goodsCategory: goodsCategoryReducer,
  goodsOperational: goodsOperationalReducer,
  deliveryVehicle: deliveryVehicleReducer,
  customer: customerReducer,
  userManagement: userManagementReducer,
  dailyActivity: dailyActivityReducer,
  reportDailyActivity: reportDailyActivityReducer,
  harvestEstimate: harvestEstimateReducer,
  reportHarvestEstimate: reportHarvestEstimateReducer,
  harvest: harvestReducer,
  reportHarvest: reportHarvestReducer,
  purchaseOrder: purchaseOrderReducer,
  purchaseOrderCust: purchaseOrderCustReducer,
  leftBar: leftBarReducer,
  stockVegetables: stockVegetablesReducer,
  stockOperationalGoods: stockOperationalGoodsReducer,
  deliveryOrder: deliveryOrderReducer,
  invoice: invoiceReducer,
  debtPlastic: debtPlasticReducer,
  operationalSubmission: operationalSubmissionReducer,
  debtMoney: debtMoneyReducer,
  purchaseOrderFarmer: purchaseOrderFarmerReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
